<div class="ui-kanban" cdkDropListGroup role="region" aria-label="Tableau Kanban">
  @for (column of columns(); track column.id) {
    <ui-kanban-column
      [title]="column.title"
      [itemCount]="column.items.length"
    >
      <div
        class="ui-kanban__dropzone"
        cdkDropList
        [cdkDropListData]="column.id"
        (cdkDropListDropped)="onDrop($event, column.id)"
      >
        @for (item of column.items; track item.id ?? $index) {
          <div
            class="ui-kanban__card"
            cdkDrag
            [cdkDragData]="item"
            (cdkDragStarted)="onDragStarted(item)"
            (cdkDragEnded)="onDragEnded()"
            tabindex="0"
            role="button"
            [class.ui-kanban__card--dragging]="draggingItemId() === item.id"
            (click)="itemClick.emit(item)"
            (keydown)="onCardKeydown(column.id, item, $event)"
          >
            @if (cardTemplate(); as template) {
              <ng-container *ngTemplateOutlet="template; context: { $implicit: item }" />
            } @else {
              <span class="ui-kanban__card-label">{{ cardLabel()(item) }}</span>
            }
          </div>
        }
      </div>
    </ui-kanban-column>
  }
</div>
